// eslint-disable-next-line import/no-extraneous-dependencies
import 'tailwindcss/dist/base.min.css';
